"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Organization = void 0;
const Photo_1 = require("./Photo");
const EsText_1 = require("./EsText");
const CommonDto_1 = require("../dto/CommonDto");
class Organization {
    constructor(title, titleShort, description, content, logo, cover, ogImage, primaryColor, updated) {
        this.title = title;
        this.titleShort = titleShort;
        this.description = description;
        this.content = content;
        this.logo = logo;
        this.cover = cover;
        this.ogImage = ogImage;
        this.primaryColor = primaryColor;
        this.updated = updated;
    }
    static createEmpty() {
        return new Organization("", "", "", EsText_1.EsText.createEmpty(), null, null, null, "", 0);
    }
    get shortTitleOrTitle() {
        return this.titleShort ? this.titleShort : this.title;
    }
    get hasLogo() {
        return this.logo !== null;
    }
    lqLogoUrl() {
        return this.hasLogo ? this.logo.lq.url : "";
    }
    get primaryColorOrGrey100() {
        if (this.primaryColor) {
            return this.primaryColor;
        }
        else {
            return "#f8f9fa";
        }
    }
    get ogImageOrLogo() {
        if (this.ogImage) {
            return this.ogImage.hq.url;
        }
        else {
            if (this.logo) {
                return this.logo.hq.url;
            }
            else {
                return "";
            }
        }
    }
    static fromDto(dto) {
        return new Organization(dto.title, dto.titleShort ? dto.titleShort : "", dto.description ? dto.description : "", EsText_1.EsText.fromOptionalTextDto(dto.content), dto.logo && dto.logo.type === CommonDto_1.PhotoType.PHOTO ? Photo_1.Photo.fromDto(dto.logo) : null, dto.cover && dto.cover.type === CommonDto_1.PhotoType.PHOTO ? Photo_1.Photo.fromDto(dto.cover) : null, dto.ogImage && dto.ogImage.type === CommonDto_1.PhotoType.PHOTO ? Photo_1.Photo.fromDto(dto.ogImage) : null, dto.primaryColor ? dto.primaryColor : "", dto.updated);
    }
    toDto() {
        const dto = {
            title: this.title,
            updated: this.updated
        };
        if (this.titleShort) {
            dto.titleShort = this.titleShort;
        }
        if (this.description) {
            dto.description = this.description;
        }
        if (this.content.notEmpty) {
            dto.content = this.content.toOptionalTextDto();
        }
        if (this.logo) {
            dto.logo = this.logo.toDto();
        }
        if (this.cover) {
            dto.cover = this.cover.toDto();
        }
        if (this.ogImage) {
            dto.ogImage = this.ogImage.toDto();
        }
        if (this.primaryColor) {
            dto.primaryColor = this.primaryColor;
        }
        dto.updated = this.updated;
        return dto;
    }
}
exports.Organization = Organization;
